// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3p_Ez","noInteraction":"EventWrapper_noInteraction__wqGH7","pointerPassthrough":"EventWrapper_pointerPassthrough__1t4ci"};